import { createContext, FC, useMemo } from 'react'
import {
  NotificationsCategory,
  NotificationTypeEnum,
} from '@tabeeb/contracts/microservices/swagger-notifications-service'
import { useNotificationSettings } from '../hooks'

interface UserNotificationSettingsContextType {
  settingsInProcessing: NotificationTypeEnum[]
  notificationsCategories: NotificationsCategory[]
  isLoading: boolean
  isError: boolean
  isFetching: boolean
  onNotificationSettingChange: (notificationType: NotificationTypeEnum, enabled: boolean) => void
}

export const UserNotificationSettingsContext = createContext<UserNotificationSettingsContextType>({
  settingsInProcessing: [],
  notificationsCategories: [],
  isLoading: false,
  isError: false,
  isFetching: false,
  onNotificationSettingChange: () => {},
})

const UserNotificationSettingsContextProvider: FC = ({ children }) => {
  const { settingsInProcessing, notificationsCategories, isLoading, isError, isFetching, onNotificationSettingChange } =
    useNotificationSettings()

  const ctxValue = useMemo<UserNotificationSettingsContextType>(
    () => ({
      settingsInProcessing,
      notificationsCategories,
      isLoading,
      isError,
      isFetching,
      onNotificationSettingChange,
    }),
    [settingsInProcessing, notificationsCategories, isLoading, isError, isFetching, onNotificationSettingChange]
  )

  return (
    <UserNotificationSettingsContext.Provider value={ctxValue}>{children}</UserNotificationSettingsContext.Provider>
  )
}

export default UserNotificationSettingsContextProvider
